import { Skeleton } from 'antd'
import Styles from './Loading.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Loading = () => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.container} data-testid="loading">
      <div className={Styles.headerContainer}>
        <Skeleton active paragraph={false} className={Styles.header} />
      </div>
      <div className={Styles.grid}>
        <Skeleton avatar active paragraph={false} title={false} className={Styles.gridOne} />
        <Skeleton avatar active paragraph={false} title={false} className={Styles.gridTwo} />
        <Skeleton avatar active paragraph={false} title={false} className={Styles.gridThree} />
        {!isMobile && <Skeleton avatar active paragraph={false} title={false} className={Styles.gridFour} />}
      </div>
      <div className={Styles.middle}>
        <div className={Styles.title}>
          <Skeleton avatar active paragraph={false} title={false} className={Styles.titleOne} />
          <Skeleton avatar active paragraph={false} title={false} className={Styles.titleTwo} />
        </div>
        <div className={Styles.buttonContainer}>
          <Skeleton avatar active paragraph={false} title={false} className={Styles.button} />
        </div>
      </div>
      <div className={Styles.bottom}>
        <div className={Styles.titleContainer}>
          <Skeleton avatar active paragraph={false} title={false} className={Styles.title} />
        </div>
        <div className={Styles.bottomLinkContainer}>
          <div className={Styles.linkContainer}>
            <Skeleton avatar active paragraph={false} title={false} className={Styles.link} />
          </div>
          {!isMobile && (
            <div className={Styles.buttonContainer}>
              <Skeleton avatar active paragraph={false} title={false} className={Styles.button} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
